import { createSlice } from "@reduxjs/toolkit";

import {
  createPearls,
  deletePearls,
  duplicatePearls,
  fetchPearlsDetails,
  listPearls,
  updatePearls
} from "../../actions/feed/pearls";

const pearlInitialState = {
  post_id: "",
  hcc_number: "",
  pearl_dx: "",
  description: "",
  primary_tags: [],
  secondary_tags: [],
  categories: [],
  content_type: "FREE",
  user_type: [],
  user_role: [],
  start_date: undefined,
  end_date: undefined,
  is_recurring: false,
  organization: [],
  all_org_access: false,
  all_user_role_access: false,
  all_user_type_access: false,
  pearl_sub_dx: [
    {
      title: "",
      definition: "",
      requirements: ""
    }
  ]
};

const initialState = {
  pearlsList: undefined,
  pearlsDetails: pearlInitialState,
  pearlValidationErrors: {},
  pearlsListLoading: false,
  pearlsDetailsLoading: false,
  pearlsCreating: false,
  pearlsUpdating: false,
  pearlsDeleting: false,
  pearlsDuplicating: false
};

export const pearlSlice = createSlice({
  name: "pearls",
  initialState,
  reducers: {
    resetPearlsDetails: (state) => {
      state.pearlsDetails = pearlInitialState;
      state.pearlValidationErrors = {};
    },
    setPearlsDetails: (state, { payload }) => {
      if (payload.pearl_sub_dx) {
        const pearlSubDx = payload.pearl_sub_dx;
        const newPearlSubDx = pearlSubDx.filter((e, idx) => {
          return idx !== pearlSubDx.length - 1
            ? e.title || e.definition || e.requirements
            : true;
        });
        payload.pearl_sub_dx = newPearlSubDx;
      }
      state.pearlsDetails = { ...state.pearlsDetails, ...payload };
      // reset validation errors of the payload if they exist
      for (const key in payload) {
        if (state.pearlValidationErrors[key]) {
          delete state.pearlValidationErrors[key];
        }
      }
    },
    setPearlsValidationErrors: (state, { payload }) => {
      state.pearlValidationErrors = payload;
    },
    validatePearlsDetails: (state) => {
      const errors = {};
      if (!state.pearlsDetails.pearl_dx) {
        errors.pearl_dx = "Title is required";
      }
      if (!state.pearlsDetails.primary_tags.length) {
        errors.primary_tags = "Primary tags are required";
      }
      if (!state.pearlsDetails.secondary_tags.length) {
        errors.secondary_tags = "Secondary tags are required";
      }
      if (!state.pearlsDetails.categories.length) {
        errors.categories = "Categories are required";
      }
      state.pearlValidationErrors = errors;
    }
  },
  extraReducers: {
    [listPearls.pending]: (state) => {
      state.pearlsListLoading = true;
      state.pearlsList = undefined;
    },
    [listPearls.fulfilled]: (state, { payload }) => {
      state.pearlsList = payload;
      state.pearlsListLoading = false;
    },
    [listPearls.rejected]: (state) => {
      state.pearlsListLoading = false;
    },
    [createPearls.pending]: (state) => {
      state.pearlsCreating = true;
    },
    [createPearls.fulfilled]: (state) => {
      state.pearlsCreating = false;
    },
    [createPearls.rejected]: (state, { error, payload }) => {
      state.pearlsCreating = false;
      state.pearlValidationErrors = payload;
    },
    [updatePearls.pending]: (state) => {
      state.pearlsUpdating = true;
    },
    [updatePearls.fulfilled]: (state) => {
      state.pearlsUpdating = false;
    },
    [updatePearls.rejected]: (state, { error, payload }) => {
      state.pearlsUpdating = false;
      state.pearlValidationErrors = payload;
    },
    [deletePearls.pending]: (state) => {
      state.pearlsDeleting = true;
    },
    [deletePearls.fulfilled]: (state) => {
      state.pearlsDeleting = false;
    },
    [deletePearls.rejected]: (state) => {
      state.pearlsDeleting = false;
    },
    [fetchPearlsDetails.pending]: (state) => {
      state.pearlsDetailsLoading = true;
      state.pearlsDetails = pearlInitialState;
    },
    [fetchPearlsDetails.fulfilled]: (state, { payload }) => {
      state.pearlsDetails = payload;
      state.pearlsDetailsLoading = false;
    },
    [fetchPearlsDetails.rejected]: (state) => {
      state.pearlsDetailsLoading = false;
    },
    [duplicatePearls.pending]: (state) => {
      state.pearlsDuplicating = true;
    },
    [duplicatePearls.fulfilled]: (state) => {
      state.pearlsDuplicating = false;
    },
    [duplicatePearls.rejected]: (state) => {
      state.pearlsDuplicating = false;
    }
  }
});

export const { resetPearlsDetails, setPearlsDetails, validatePearlsDetails } =
  pearlSlice.actions;

export default pearlSlice.reducer;
